const messages = {
  GlobalClose: 'global.Close',
  RelatedArticlesShowMore: 'relatedArticles.showMore',
  RelatedArticlesReadMore: 'relatedArticles.readMore',
  NewsletterSuccessMessageHeadline: 'newsletter.successMessageHeadline',
  NewsletterSuccessMessageDescription: 'newsletter.successMessageDescription',
  NewsletterSuccessMessageButton: 'newsletter.successMessageButton',
  NewsletterUserAlreadySubscribed: 'newsletter.userAlreadySubscribed',
  NewsletterEnterAValidEmailAddress: 'newsletter.enterAValidEmailAddress',
  NewsletterSubscriptionCannotBeProcessed: 'newsletter.userSubscriptionCannotBeProcessed',
  FormInvalidEmailFormat: 'form.invalidEmailFormat',
  FormRequiredField: 'form.requiredField',
  FormTryAgain: 'form.tryAgain',
  PrognoseChartInputsHeading: 'PrognoseChart.inputs.heading',
  PrognoseChartInputsOneTimeInvestmentLabel: 'PrognoseChart.inputs.oneTimeInvestment.label',
  PrognoseChartInputsOneTimeInvestmentPlaceholder:
    'PrognoseChart.inputs.oneTimeInvestment.placeholder',
  PrognoseChartInputsOneTimeInvestmentHelperMin: 'PrognoseChart.inputs.minOneTimeInvestment.helper',
  PrognoseChartInputsOneTimeInvestmentHelperMax: 'PrognoseChart.inputs.maxOneTimeInvestment.helper',
  PrognoseChartInputsMonthlySavingRateLabel: 'PrognoseChart.inputs.monthlySavingRate.label',
  PrognoseChartInputsMonthlySavingRatePlaceholder:
    'PrognoseChart.inputs.monthlySavingRate.placeholder',
  PrognoseChartInputsMonthlySavingRateHelperMin: 'PrognoseChart.inputs.minMonthlySavingRate.helper',
  PrognoseChartInputsMonthlySavingRateHelperMax: 'PrognoseChart.inputs.maxMonthlySavingRate.helper',
  PrognoseChartInputsPortfolioLabel: 'PrognoseChart.inputs.portfolio.label',
  PrognoseChartInputsPortfolioPlaceholder: 'PrognoseChart.inputs.portfolio.placeholder',
  PrognoseChartInputsPortfolioValue30: 'PrognoseChart.inputs.portfolio.value.30',
  PrognoseChartInputsPortfolioValue50: 'PrognoseChart.inputs.portfolio.value.50',
  PrognoseChartInputsPortfolioValue70: 'PrognoseChart.inputs.portfolio.value.70',
  PrognoseChartInputsPortfolioValue100: 'PrognoseChart.inputs.portfolio.value.100',
  PrognoseChartInputsNotesHeader: 'PrognoseChart.inputs.notes.header',
  PrognoseChartInputsNotesParagraph: 'PrognoseChart.inputs.notes.paragraph',
  PrognoseChartInputsOpenModalCTA: 'PrognoseChart.inputs.openModal.cta',
  PrognoseChartInputsModalHeading: 'PrognoseChart.inputs.modal.heading',
  PrognoseChartInputsModalParagraph: 'PrognoseChart.inputs.modal.paragraph',
  DWMPrognoseChartRiskParagraph: 'DWM.PrognoseChart.riskText',
  PrognoseChartInputsModalCta: 'PrognoseChart.inputs.modal.cta',
  PrognoseChartBoxHeading: 'PrognoseChart.chart.heading',
  PrognoseChartBoxPercentNote: 'PrognoseChart.chart.percentNote',
  PrognoseChartBoxDuration1: 'PrognoseChart.chart.duration.1',
  PrognoseChartBoxDuration2: 'PrognoseChart.chart.duration.2',
  PrognoseChartBoxDuration3: 'PrognoseChart.chart.duration.3',
  PrognoseChartBoxErrorMsg: 'PrognoseChart.chart.errorMsg',
  PrognoseChartBoxNote: 'PrognoseChart.chart.note',
  PrognoseChartBoxLegend1: 'PrognoseChart.chart.legend1',
  PrognoseChartBoxLegend2: 'PrognoseChart.chart.legend2',
  PrognoseChartBoxLegend3: 'PrognoseChart.chart.legend3',
  PrognoseChartBoxLegend4: 'PrognoseChart.chart.legend4',
  PrognoseChartHeading: 'PrognoseChart.heading',
  DWMPrognoseChartHeading: 'DWM.PrognoseChart.heading',
  DWMPrognoseChartSubHeading: 'DWM.PrognoseChart.subheading',
  DWMPrognoseChartParagraph: 'DWM.PrognoseChart.paragraph',
  DWMPrognoseChartInputsOneTimeInvestmentLabel: 'DWM.PrognoseChart.inputs.oneTimeInvestment.label',
  DWMPrognoseChartInputsOneTimeInvestmentPlaceholder:
    'DWM.PrognoseChart.inputs.oneTimeInvestment.placeholder',
  DWMPrognoseChartInputsOneTimeInvestmentHelpermin:
    'DWM.PrognoseChart.inputs.minOneTimeInvestment.helper',
  DWMPrognoseChartInputsOneTimeInvestmentHelpermax:
    'DWM.PrognoseChart.inputs.maxOneTimeInvestment.helper',
  DWMPrognoseChartInputsMonthlySavingRateLabel: 'DWM.PrognoseChart.inputs.monthlySavingRate.label',
  DWMPrognoseChartInputsMonthlySavingRatePlaceholder:
    'DWM.PrognoseChart.inputs.monthlySavingRate.placeholder',
  DWMPrognoseChartInputsMonthlySavingRateHelpermin:
    'DWM.PrognoseChart.inputs.minMonthlySavingRate.helper',
  DWMPrognoseChartInputsMonthlySavingRateHelpermax:
    'DWM.PrognoseChart.inputs.maxMonthlySavingRate.helper',
  DWMPrognoseChartInputsDurationLabel: 'DWM.PrognoseChart.inputs.duration.label',
  DWMPrognoseChartBoxDuration: 'DWM.PrognoseChart.chart.duration',
  DWMPrognoseChartInputsPortfolioLabel: 'DWM.PrognoseChart.inputs.portfolio.label',
  DWMPrognoseChartInputsPortfolioValue30: 'DWM.PrognoseChart.inputs.portfolio.value.30',
  DWMPrognoseChartInputsPortfolioValue50: 'DWM.PrognoseChart.inputs.portfolio.value.50',
  DWMPrognoseChartInputsPortfolioValue70: 'DWM.PrognoseChart.inputs.portfolio.value.70',
  DWMPrognoseChartInputsPortfolioValue100: 'DWM.PrognoseChart.inputs.portfolio.value.100',
  DWMPrognoseChartInputsPortfolioValueMM: 'DWM.PrognoseChart.inputs.portfolio.value.mm',
  DWMPrognoseChartFooter: 'DWM.PrognoseChart.footer',
  DWMPrognoseChartOpenModalCTA: 'DWM.PrognoseChart.openModal.cta',
  DWMPrognoseChartModalHeading: 'DWM.PrognoseChart.modal.heading',
  DWMPrognoseChartModalParagraph: 'DWM.PrognoseChart.modal.paragraph',
  DWMPrognoseChartModalCta: 'DWM.PrognoseChart.modal.cta',
  DWMPrognoseChartBoxErrorMsg: 'DWM.PrognoseChart.chart.errorMsg',
  DWMPrognoseChartLegendTotalContributes: 'DWM.PrognoseChart.legend.totalContributes',
  DWMPrognoseChartLegendTotalReturn: 'DWM.PrognoseChart.legend.totalReturn',
  DWMPrognoseChartLegendCostsPerYear: 'DWM.PrognoseChart.legend.costsPerYear',
  DWMPrognoseChartLegendFinalCapital: 'DWM.PrognoseChart.legend.finalCapital',
  rate: 'rate',
  rateSharia: 'rate.sharia',
  bank: 'bank',
  country: 'country',
  term: 'term',
  actualTermInWeeks: 'actualTermInWeeks',
  month: 'month',
  months: 'months',
  perYear: 'perYear',
  perYearNominalRate: 'perYearNominalRate',
  perYearEffectiveRate: 'perYearEffectiveRate',
  perYearTermDeposit: 'perYearTermDeposit',
  perYearNoticeAcc: 'perYearNoticeAcc',
  perYearOvernight: 'perYearOvernight',
  overnightDeposit: 'overnightDeposit',
  offerDetails: 'offerDetails',
  offerPromotionalFlagText: 'offerPromotionalFlagText',
  year: 'year',
  years: 'years',
  yearsPL: 'yearsPL',
  offerIn: 'offerIn',
  showAll: 'showAll',
  OTCountryFilterPlaceholderText: 'OTCountryFilterPlaceholderText',
  upToThreeMonths: 'upToThreeMonths',
  sixToNineMonths: 'sixToNineMonths',
  noOffersFound: 'noOffersFound',
  loadMoreOffers: 'loadMoreOffers',
  investNowCTA: 'investNowCTA',
  interestInformation: 'interestInformation',
  interestInformationSharia: 'interestInformation.sharia',
  productDetails: 'productDetails',
  nominalRate: 'nominalRate',
  nominalRateSharia: 'nominalRate.sharia',
  effectiveRate: 'effectiveRate',
  effectiveRateSharia: 'effectiveRate.sharia',
  availability: 'availability',
  availabilityFlexgeld: 'availabilityFlexgeld',
  availabilityTermDeposit: 'availabilityTermDeposit',
  availabilityOvernightDeposit: 'availabilityOvernightDeposit',
  interestPayout: 'interestPayout',
  interestPayoutSharia: 'interestPayout.sharia',
  interestEarlyTermination: 'interestEarlyTermination',
  interestEarlyTerminationSharia: 'interestEarlyTermination.sharia',
  interestTaxation: 'interestTaxation',
  interestTaxationSharia: 'interestTaxation.sharia',
  depositGuarantee: 'depositGuarantee',
  depositGuaranteeValue: 'depositGuaranteeValue',
  currency: 'currency',
  minMaxInvestmentAmount: 'minMaxInvestmentAmount',
  withholdingTax: 'withholdingTax',
  productInformationSheet: 'productInformationSheet',
  interestPayoutSchemeAnnually: 'interestPayoutSchemeAnnually',
  interestPayoutSchemeMonthly: 'interestPayoutSchemeMonthly',
  interestPayoutSchemeQuarterly: 'interestPayoutSchemeQuarterly',
  interestPayoutSchemeMaturity: 'interestPayoutSchemeMaturity',
  flexgeldFilter: 'flexgeldFilter',
  flexgeldFilterTooltip: 'flexgeldFilterTooltip',
  foreignCurrencyFilter: 'foreignCurrencyFilter',
  foreignCurrencyFilterTooltip: 'foreignCurrencyFilterTooltip',
  chipCurrencyLabel: 'chipCurrencyLabel',
  chipCurrencyTooltip: 'chipCurrencyTooltip',
  chipShariaLabel: 'chipShariaLabel',
  chipShariaTooltip: 'chipShariaTooltip',
  chipFlexgeldLabel: 'chipFlexgeldLabel',
  chipFlexgeldTooltip: 'chipFlexgeldTooltip',
  chipSpecialLabel: 'chipSpecialLabel',
  chipFinanzBestLabel: 'chipFinanzBestLabel',
  chipFinanzBestTooltip: 'chipFinanzBestTooltip',
  chipRateDecreaseLabel: 'chipRateDecreaseLabel',
  chipRateDecreaseTooltip: 'chipRateDecreaseTooltip',
  chipRaisinLabel: 'chipRaisinLabel',
  chipRaisinTooltip: 'chipRaisinTooltip',
  chipFullOnlineLabel: 'chipFullOnlineLabel',
  chipFullOnlineTooltip: 'chipFullOnlineTooltip',
  bankInfoHeading: 'bankInfoHeading',
  termDepositTabTitle: 'termDepositTab.title',
  termDepositTabSubtitle: 'termDepositTab.subtitle',
  OvernightTabTitle: 'OvernightTab.title',
  OvernightTabSubtitle: 'OvernightTab.subtitle',
  FlexgeldTabTitle: 'FlexgeldTab.title',
  FlexgeldTabSubtitle: 'FlexgeldTab.subtitle',
  investmentAmount: 'investmentAmount',
  investmentAmountPlaceholder: 'investmentAmountPlaceholder',
  depositProtection: 'depositProtection',
  maxDepositProtection: 'maxDepositProtection',
  variable: 'variable',
  aboutTheCountry: 'aboutTheCountry',
  bankAdditionalDetails: 'bankAdditionalDetails',
  easyAccess: 'easyAccess',
  chipEasyAccessLabel: 'chipEasyAccessLabel',
  chipEasyAccessTooltip: 'chipEasyAccessTooltip',
  depositGuaranteeHeading: 'depositGuaranteeHeading',
  countryCreditRatingTooltip: 'countryCreditRatingTooltip',
  compounding: 'compounding',
  compoundingSharia: 'compounding.sharia',
  yes: 'yes',
  no: 'no',
  interestBooking: 'interestBooking',
  interestPayment: 'interestPayment',
  interestBookingLabelsAnnually: 'interestBookingLabelsAnnually',
  interestBookingLabelsMaturity: 'interestBookingLabelsMaturity',
  interestBookingLabelsMonthly: 'interestBookingLabelsMonthly',
  interestBookingLabelsQuarterly: 'interestBookingLabelsQuarterly',
  interestType: 'interestType',
  interestTypeSharia: 'interestType.sharia',
  interestTypeForFestgeld: 'interestTypeForFestgeld',
  interestTypeForFlexgeld: 'interestTypeForFlexgeld',
  interestTypeForOvernight: 'interestTypeForOvernight',
  importantInformation: 'importantInformation',
  representativeExampleLabel: 'representativeExampleLabel',
  representativeExampleTermDeposit1: 'representativeExampleTermDeposit1',
  representativeExampleTermDeposit2: 'representativeExampleTermDeposit2',
  representativeExampleTermDeposit3: 'representativeExampleTermDeposit3',
  representativeExampleTermDeposit4: 'representativeExampleTermDeposit4',
  representativeExampleTermDeposit5: 'representativeExampleTermDeposit5',
  representativeExampleCommon: 'representativeExampleCommon',
  representativeExampleOvernightAndNoticeAccount1:
    'representativeExampleOvernightAndNoticeAccount1',
  representativeExampleOvernightAndNoticeAccount2:
    'representativeExampleOvernightAndNoticeAccount2',
  representativeExampleOvernightAndNoticeAccount3:
    'representativeExampleOvernightAndNoticeAccount3',
  representativeExampleOvernightAndNoticeAccount4:
    'representativeExampleOvernightAndNoticeAccount4',
  representativeExampleOvernight: 'representativeExampleOvernight',
  representativeExampleOvernightMONTHLY: 'representativeExampleOvernightMONTHLY',
  representativeExampleOvernightQUARTERLY: 'representativeExampleOvernightQUARTERLY',
  representativeExampleOvernightANUALLY: 'representativeExampleOvernightANUALLY',
  specialFeatures: 'specialFeatures',
  specialFeaturesDescription: 'specialFeaturesDescription',
  costs: 'costs',
  localCurrencyCostsDescription: 'localCurrencyCostsDescription',
  foreignCurrencyCostsDescription: 'foreignCurrencyCostsDescription',
  prolongation: 'prolongation',
  hasAutoProlongation: 'hasAutoProlongation',
  hasNotAutoProlongation: 'hasNotAutoProlongation',
  prolongationNotEnabled: 'prolongationNotEnabled',
  additionalDocuments: 'additionalDocuments',
  nonAdditionalDocuments: 'nonAdditionalDocuments',
  digiAdditionalDocuments: 'digiAdditionalDocuments',
  paperAdditionalDocuments: 'paperAdditionalDocuments',
  terminationNoticePeriod: 'terminationNoticePeriod',
  noticePeriodAvailabilityText: 'noticePeriodAvailabilityText',
  noticePeriod: 'noticePeriod',
  noticeAccountTabTitle: 'noticeAccountTab.title',
  noticeAccountTabSubtitle: 'noticeAccountTab.subtitle',
  countryCreditRatingFilter: 'countryCreditRatingFilter',
  countriesFilter: 'countryFilter',
  allCountriesFiltersOption: 'allCountriesFiltersOption',
  bestCountryCreditRating: 'bestCountryCreditRating',
  veryGoodOrHigherCountryCreditRating: 'veryGoodOrHigherCountryCreditRating',
  goodOrHigherCountryCreditRating: 'goodOrHigherCountryCreditRating',
  acceptableOrHigherCountryCreditRating: 'acceptableOrHigherCountryCreditRating',
  offerOverviewCallalikeAvailability: 'offerOverviewCallalikeAvailability',
  offerDetailsCallalikeTermValue: 'offerDetailsCallalikeTermValue',
  offerDetailsCallalikeAvailabilityValue: 'offerDetailsCallalikeAvailabilityValue',
  settlementDayUnitMONDAY: 'settlementDayUnitMONDAY',
  settlementDayUnitTUESDAY: 'settlementDayUnitTUESDAY',
  settlementDayUnitWEDNESDAY: 'settlementDayUnitWEDNESDAY',
  settlementDayUnitTHURSDAY: 'settlementDayUnitTHURSDAY',
  settlementDayUnitFRIDAY: 'settlementDayUnitFRIDAY',
  settlementDayUnitSATURDAY: 'utils.settlementDay.unit.saturday',
  settlementDayUnitSUNDAY: 'utils.settlementDay.unit.sunday',
  variableInterestTypeInAER: 'variableInterestTypeInAER',
  fixedInterestTypeInAER: 'fixedInterestTypeInAER',
  bonusLabel: 'bonusLabel',
  bonusTooltip: 'bonusTooltip',
  interestEarnedAmount: 'interestEarnedAmount',
  interest: 'interest',
  interestAndBonus: 'interestAndBonus',
  tabWeltInvestTabTitle: 'tab.weltInvestTab.title',
  tabWeltInvestTabSubtitle: 'tab.weltInvestTab.subtitle',
  tabFairrTabTitle: 'tab.fairrTab.title',
  tabFairrTabSubtitle: 'tab.fairrTab.subtitle',
  chipNoWithholdingTaxLabel: 'chipNoWithholdingTaxLabel',
  chipNoWithholdingTaxTooltip: 'chipNoWithholdingTaxTooltip',
  chipNoForeignTaxLabel: 'chipNoForeignTaxLabel',
  chipNoForeignTaxTooltip: 'chipNoForeignTaxTooltip',
  chipAutomaticTaxHandlingLabel: 'chipAutomaticTaxHandlingLabel',
  chipAutomaticTaxHandlingTooltip: 'chipAutomaticTaxHandlingTooltip',
  chipFixedInvestmentAmountLabel: 'chipFixedInvestmentAmountLabel',
  chipFixedInvestmentAmountTooltip: 'chipFixedInvestmentAmountTooltip',
  negativeInterestBooking: 'negativeInterestBooking',
  negativeInterestPayment: 'negativeInterestPayment',
  negativeInterestPaymentSharia: 'negativeInterestPayment.sharia',
  raisinInvestTabTitle: 'tab.weltInvestTab.title',
  raisinInvestTabSubTitle: 'tab.weltInvestTab.subtitle',
  raisinPensionTabTitle: 'tab.fairrTab.title',
  raisinPensionTabSubTitle: 'tab.fairrTab.subtitle',
  chipStructuredDepositLabel: 'chipStructuredDepositLabel',
  chipStructuredDepositTooltip: 'chipStructuredDepositTooltip',
  chipMarketLeadingRateLabel: 'chipMarketLeadingRateLabel',
  chipMarketLeadingRateTooltip: 'chipMarketLeadingRateTooltip',
  chipRateReducingSoonLabel: 'chipRateReducingSoonLabel',
  chipRateReducingSoonTooltip: 'chipRateReducingSoonTooltip',
  chipTopOfferLabel: 'chipTopOfferLabel',
  chipTopOfferTooltip: 'chipTopOfferTooltip',
  chipSustainableLabel: 'chipSustainableLabel',
  chipSustainableTooltip: 'chipSustainableTooltip',
  riskHead: 'riskClasses.head',
  riskParagraph: 'riskClasses.paragraph',
  portfolioDetailsModalTitle: 'riskClasses.portfolioDetails.title',
  securityDocumentsModalTitle: 'riskClasses.portfolioDetails.securityDetails.documents.title',
  securityDetailsTitle: 'riskClasses.portfolioDetails.securityDetails.title',
  securityDetailsHead1: 'riskClasses.portfolioDetails.securityDetails.head1',
  securityDetailsHead2: 'riskClasses.portfolioDetails.securityDetails.head2',
  ISIN: 'riskClasses.portfolioDetails.securityDetails.ISIN',
  portfolioInfoTitle: 'riskClasses.portfolioDetails.portfolioInfo.title',
  portfolioInfoDetails: 'riskClasses.portfolioDetails.portfolioInfo.description',
  highRisk: 'riskClasses.portfolioDetails.portfolioInfo.highRisk',
  lowRisk: 'riskClasses.portfolioDetails.portfolioInfo.lowRisk',
  fees: 'riskClasses.portfolioDetails.portfolioInfo.fees',
  fundCost: 'riskClasses.portfolioDetails.portfolioInfo.fundCost',
  targetReturn: 'riskClasses.portfolioDetails.portfolioInfo.targetReturn',
  maximumDrawdown: 'riskClasses.portfolioDetails.portfolioInfo.maximumDrawdown',
  ETF: 'riskClasses.portfolioDetails.portfolioInfo.ETF',
  funds: 'riskClasses.portfolioDetails.portfolioInfo.funds',
  portfolio100: 'riskClasses.portfolio.100',
  portfolio70: 'riskClasses.portfolio.70',
  portfolio50: 'riskClasses.portfolio.50',
  portfolio30: 'riskClasses.portfolio.30',
  portfolioMM: 'riskClasses.portfolio.mm',
  portfolioCaption100: 'riskClasses.portfolio.caption.100',
  portfolioCaption70: 'riskClasses.portfolio.caption.70',
  portfolioCaption50: 'riskClasses.portfolio.caption.50',
  portfolioCaption30: 'riskClasses.portfolio.caption.30',
  portfolioCaptionMM: 'riskClasses.portfolio.caption.mm',
  portfolioParagraph100: 'riskClasses.portfolio.paragraph.100',
  portfolioParagraph70: 'riskClasses.portfolio.paragraph.70',
  portfolioParagraph50: 'riskClasses.portfolio.paragraph.50',
  portfolioParagraph30: 'riskClasses.portfolio.paragraph.30',
  portfolioParagraphMM: 'riskClasses.portfolio.paragraph.mm',
  new: 'riskClasses.portfolio.new',
  cta: 'riskClasses.portfolio.CTA',
  ribbonRateDecreasing: 'ribbonRateDecreasing',
  bankPageTitle: 'bankPageTitle',
  riskBannerCenterBoxMessage: 'riskBannerCenterBoxMessage',
  riskBannerLeftBoxMessage: 'riskBannerLeftBoxMessage',
  riskBannerRightBoxMessage: 'riskBannerRightBoxMessage',
  productTypeNotice: 'productType.notice',
  productTypeNoticeAccount: 'productType.noticeAccount',
  productTypeOvernight: 'productType.overnight',
  productTypeTerm: 'productType.term',
  productTermDays: 'productTerm.days',
  productTermMonths: 'productTerm.months',
  productTermWeeks: 'productTerm.weeks',
  productTermYears: 'productTerm.years',
  dayTerm: 'term.day',
  weekTerm: 'term.week',
  monthTerm: 'term.month',
  yearTerm: 'term.year',
  daysTerm: 'term.days',
  weeksTerm: 'term.weeks',
  monthsTerm: 'term.months',
  yearsTerm: 'term.years',
  yearsTermPL: 'term.yearsPL',
  customerOffBoardingTitle: 'notification.offBoarding.title',
  customerOffBoardingBody: 'notification.offBoarding.body',
  notFoundPageDocumentTitle: 'notFoundPage.document.title',
  notFoundPageTitle: 'notFoundPage.title',
  notFoundPageDescription: 'notFoundPage.description',
  notFoundPageMainCTAText: 'notFoundPage.mainCTAText',
  notFoundPageFirstLink: 'notFoundPage.links.first',
  notFoundPageSecondLink: 'notFoundPage.links.second',
  notFoundPageThirdLink: 'notFoundPage.links.third',
  usOfferTableDisclaimer: 'usOfferTable.disclaimer',
  usOfferTableNoProducts: 'usOfferTable.noProducts',
  usOfferTableLoadMore: 'usOfferTable.loadMore',
  usOfferTableAnnualizedEarningTooltip: 'usOfferTable.annualizedEarningTooltip',
  usOfferTableSaveButton: 'usOfferTable.saveButton',
  usOfferTableProductTerms: 'usOfferTable.productTerms',
  usOfferTableHeaderBank: 'usOfferTable.header.bank',
  usOfferTableHeaderProduct: 'usOfferTable.header.product',
  usOfferTableHeaderApy: 'usOfferTable.header.apy',
  usOfferTableTeaserTooltip: 'usOfferTable.teaserTooltip',
  usOfferTableTeaserBadge: 'usOfferTable.teaserBadge',
  usOfferTableHeaderMaturity: 'usOfferTable.header.maturity',
  usOfferTableHeaderAnnualizedEarnings: 'usOfferTable.header.annualizedEarnings',
  bankLogoAlt: 'bankLogo.alt',
};

export default messages;
